import { useForm } from 'react-hook-form';

import useSurvey from 'store/survey/useSurvey';
import useNotification from 'hooks/useNotification';

import { Typography, Box } from '@mui/material';
import MuiDialog from 'components/MuiDialog';

import { SurveyDialogProps, TIntubationAgreeDefaultValues } from '../../type';
import { updateIntubationAgree } from 'apis/survey';

import CommonPatientInfo from '../../components/CommonPatientInfo';
import ResultPurpose from './ResultPurpose';
import CautionList from './CautionList';
import Signature from './Signature';
import Complications from './Complications';
import MethodandProcess from './MethodandProcess';

const IntubationAgreement = (
  props: SurveyDialogProps<TIntubationAgreeDefaultValues>
) => {
  const {
    title,
    isOpen,
    disabled,
    defaultValues,
    user_id,
    nurseName,
    patientInfo,
    onClose,
  } = props;

  const { onUpdateIsSave } = useSurvey();
  const { onSuccess, onFail, onResultCode, onRequired } = useNotification();
  const { handleSubmit, watch, getValues, setValue, register } = useForm({
    defaultValues,
  });

  const onSubmit = (data: TIntubationAgreeDefaultValues) => {
    const {
      no4,

      date,
      relationship,
      name,
      sign,

      dr_name,
      dr_sign,
    } = data;

    const request = {
      user_id,
      patient_id: patientInfo.patient_id,
      intubation_confirmation: {
        no4,

        date,
        relationship,
        name,
        sign,

        dr_name,
        dr_sign,
      },
    };

    // console.log('리퀘스트', request);

    updateIntubationAgree(request)
      .then(({ data: { rc } }) => {
        if (rc !== 1) return onResultCode(rc);

        onUpdateIsSave(true);
        onSuccess('Saved successfully');
      })
      .catch(e => {
        onFail('Failed to save', e);
        // console.log(e);
      });
  };

  const formProps = {
    disabled,
    watch,
    getValues,
    setValue,
    onSuccess,
    onRequired,
    register,
  };

  return (
    <MuiDialog.SurveyForm
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={disabled ? undefined : handleSubmit(onSubmit)}
      update_at={defaultValues?.update_at}
    >
      <Typography
        sx={{
          margin: '40px auto 40px auto',
          fontWeight: '700',
          fontSize: '16px',
          textAlign: 'center',
        }}
      >
        Endotracheal Intubation Consent
      </Typography>
      <CommonPatientInfo patientInfo={patientInfo} nurseName={nurseName} />
      <Box sx={{ marginTop: '48px' }}>
        <ResultPurpose {...formProps} />
        <Complications {...formProps} />
        <MethodandProcess {...formProps} />
        <Signature {...formProps} />
      </Box>
    </MuiDialog.SurveyForm>
  );
};

export default IntubationAgreement;
